export default __webpack_public_path__ + "static/media/woman.fae1ff0e.png";